export const odata = {
  methods: {
    getServiceUr: function(call, ctx, filter, orderString) {
      var skip = (ctx.currentPage - 1) * ctx.perPage;

      return (
        call +
        '?$top=' +
        ctx.perPage +
        '&$skip=' +
        skip +
        filter +
        orderString +
        '&$count=true'
      );
    },
    generateOdataOrderByConditionString: function(sortBy, sortDesc, source) {
      sortBy = this.convertId(sortBy, source);

      if (source === 'serviceCalls' && sortBy === 'serviceObjectId') {
        return (
          '&$orderby=serviceObjectId' +
          (sortDesc ? ' desc' : '') +
          ', opendate' +
          (sortDesc ? ' desc' : '')
        );
      }

      return '&$orderby=' + sortBy + (sortDesc ? ' desc' : '');
    },
    filterByContains: function(id, value, source) {
      value = value.replace(/&/g, '%26');

      value = encodeURIComponent(value);

      id = this.convertId(id, source);

      return '(contains(toLower(' + id + "),toLower('" + value + "')))";
    },
    filterByEquals: function(id, value) {
      return '(' + id + ' eq ' + value + ')';
    },
    filterByDropdownEquals: function(id, value) {
      return '(' + id + ' eq \'' + value + '\')';
    },
    filterByDateRange: function(id, startDate, endDate) {
      return (
        '(' + id + ' ge ' + startDate + ' and ' + id + ' le ' + endDate + ')'
      );
    },
    getFilterString: function(filters, source) {
      let filterConditions = [];

      for (let i = 0; i < filters.length; ++i) {
        let filter = filters[i];

        if (filter.value) {
          switch (filter.type) {
            case 'dateRange':
              let startDate = this.formatDate(filter.value.start);
              let endDate = this.formatDate(filter.value.end);

              filterConditions.push(
                this.filterByDateRange(filter.id, startDate, endDate)
              );
              break;
            case 'checkBox':
              filterConditions.push(
                this.filterByEquals(filter.id, filter.value)
              );
              break;
            case 'dropdown':
              filterConditions.push(
                this.filterByDropdownEquals(filter.id, filter.value)
              );
              break;
            default:
              filterConditions.push(
                this.filterByContains(filter.id, filter.value, source)
              );
          }
        }
      }

      let filterString = '';
      if (filterConditions.length > 0) {
        filterString = '&$filter=' + filterConditions.join('and');
      }

      return filterString;
    },
    formatDate: function(date) {
      return this.$moment(date, 'DD/MM/YYYY').format('YYYY-MM-DD');
    },
    convertId: function(id, source) {
      switch (source) {
        case 'serviceObjects':
          return this.convertServiceObjects(id);
        case 'serviceContracts':
          return this.convertServiceContracts(id);
        case 'serviceCalls':
          return this.convertServiceCalls(id);
        default:
          break;
      }

      return id;
    },
    convertServiceObjects: function(id) {
      return id;
    },
    convertServiceContracts: function(id) {
      return id;
    },
    convertServiceCalls: function(id) {
      if (id === 'serialNo') {
        id = 'serviceObject/serialNo';
      }

      if (id === 'itemId') {
        id = 'serviceObject/itemId';
      }

      return id;
    }
  }
};
